import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Roles, IxellAPIService, IColorMatchingV1, IIngredientColorMatchingV1, IFilterColorMatching, ITextSentenceColorMatchingV1, IResponseColorMatchingV1 } from 'src/app/tools/api.service';
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from 'src/app/tools/header.service';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort, Sort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';
import * as _moment from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { Constants } from 'src/app/entities/Constants';
import { UntypedFormGroup, UntypedFormControl} from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ContretypageService, Technologie } from 'src/app/tools/contretypage.service';
import { StorageService } from 'src/app/tools/storage.service';
import { getDutchPaginatorIntl } from 'src/app/tools/paginator/paginatorContretypage';

const moment = _moment;

export enum StatusColorMatchingType {
  PENDING = 1,
  RECEIVED = 2,
  FINISHED = 3
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-historique-color-matching',
  templateUrl: './historique-color-matching.component.html',
  styleUrls: ['./historique-color-matching.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },

    { provide: MatPaginatorIntl, useValue: getDutchPaginatorIntl() },
  ]
})
export class HistoriqueColorMatchingComponent implements OnInit {

  StatusColorMatchingType = StatusColorMatchingType;
  StatusCMType = StatusColorMatchingType;
  Technologie = Technologie;
  role: Roles;
  Utils = Utils;
  displayedUser = ['reference', 'status', 'dateCreate', 'ctc', 'marque', 'model', 'eltSend', 'dateReceive', 'dateFinish', 'btnVisual', 'btnPrint'];
  displayedCTC = ['reference', 'status', 'dateCreate', 'socialReason', 'client', 'marque', 'model', 'eltSend', 'dateReceive', 'dateFinish', 'btnVisual']; //, 'btnValidate']; //'btnPrint',
  displayedAXALTA = ['reference', 'numeroSuivi', 'status', 'dateCreate', 'marque', 'model', 'eltSend', 'dateReceive', 'dateFinish', 'btnVisual', 'btnCopie', 'btnExport']; // 'socialReason', 'client', 'ctc', , 'btnValidate'];
  displayedColumns: string[];
  displayedIngredients: string[] = ['position', 'code', 'name', 'quantity', 'qtyCumule'];
  histoPerso: number;
  firstDate: Date = new Date('0001-01-01');
  cumul: number;
  sortDefault: Sort;
  qrcode: string;
  infoQRCode: string;
  techDemande: string;

  // Object
  ingredientArray: MatTableDataSource<IIngredientColorMatchingV1>;
  ingr: IIngredientColorMatchingV1[];
  AllIngredientArray: IIngredientColorMatchingV1[];
  lstColorMatching: IColorMatchingV1[] = [];
  lstFilteredColorMatching: IColorMatchingV1[] = [];
  colMatching: IColorMatchingV1 = new IColorMatchingV1();
  lstTextSentencesCM: ITextSentenceColorMatchingV1[] = [];
  textSentencesCM: ITextSentenceColorMatchingV1[] = [];

  colorMatchingSource: MatTableDataSource<IColorMatchingV1> = new MatTableDataSource<IColorMatchingV1>();
  filterCM: IFilterColorMatching = new IFilterColorMatching();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  // Sub
  colorMatchingSub: any;
  colorMatchingValidationSub: any;
  private textSentenceCMSub: any;
  private ingredientCMSub: any;
  private roleSub: any;
  keys: string[];

  filterForm = new UntypedFormGroup({
    filterColorMatchingID: new UntypedFormControl(''),
    filterStatus: new UntypedFormControl(''),
    filerDateStart: new UntypedFormControl(''),
    filerDateEnd: new UntypedFormControl(''),
  })

  constructor(private headerService: HeaderService, private api: IxellAPIService, private router: Router, public datepipe: DatePipe, private ContretypageService: ContretypageService, private storageService: StorageService, private changeDetectorRefs: ChangeDetectorRef) {
    this.keys = Object.keys(this.StatusCMType).filter(k => !isNaN(Number(k)));
  }

  ngOnInit() {

    this.textSentenceCMSub = this.api.getTextSentence().subscribe(
      data => {
        if (data) {
          this.lstTextSentencesCM = data;
        }
        this.headerService.changeCanBack(true);
        this.headerService.changeTitle("IxellWebLab");
        this.headerService.changeLogo(null);

        this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);
        this.colorMatchingSource = new MatTableDataSource<IColorMatchingV1>();
        this.ingredientArray = new MatTableDataSource<IIngredientColorMatchingV1>();
        this.ingr = [];

        var statusListAxalta: any[] = [
          this.keys[0],
          this.keys[1]
        ];
        var statusList: any[] = [
          this.keys[0],
          this.keys[1],
          this.keys[2]
        ];

        var listStatusContretypage = this.storageService.get("listStatusContretypage");

        if (listStatusContretypage != null) {
          statusListAxalta = listStatusContretypage.split(",");
          statusList = listStatusContretypage.split(",");
        } else {
          if (Utils.isAxalta(this.role)) {
            this.storageService.set("listStatusContretypage", statusListAxalta.join(","));
          } else {
            this.storageService.set("listStatusContretypage", statusList.join(","));
          }
        }

        this.sort.sort(<MatSortable>({ id: 'reference', start: 'desc' }));

        if (Utils.isUserIxell(this.role)) {
          this.filterCM.histoPerso = 1;
          //this.sortDefault = { active: "dateCreate", direction: "desc" };
          this.sort.sort(({ id: 'dateCreate', start: 'desc' }) as MatSortable);
          this.filterForm.controls["filterStatus"].setValue(statusList);
        }
        else if (Utils.isCTC(this.role)) {
          this.filterCM.histoPerso = 2;
          //this.sortDefault = { active: "dateCreate", direction: "desc" };
          this.sort.sort(({ id: 'dateCreate', start: 'desc' }) as MatSortable);
          this.filterForm.controls["filterStatus"].setValue(statusList);
        }
        else if (Utils.isAxalta(this.role)) {
          this.filterCM.histoPerso = 0;
          //this.sortDefault = { active: "status", direction: "asc" };
          this.sort.sort(({ id: 'status', start: 'desc' }) as MatSortable);
          this.filterForm.controls["filterStatus"].setValue(statusListAxalta);
        }

        this.recupLstColorMatching();
        this.colorMatchingSource.paginator = this.paginator;
        this.colorMatchingSource.sort = this.sort;
        this.colorMatchingSource.sortingDataAccessor = (data, header) => data[header];

        this.ingredientCMSub = this.api.getIngredient("all").subscribe(
          data => {
            if (data) {
              this.AllIngredientArray = data;
            }
          },
          error => {
            console.log(error);
            if (this.ingredientCMSub != null) this.ingredientCMSub.unsubscribe();
          }
        );
      },
      error => {
        console.log(error);
        if (this.textSentenceCMSub != null) this.textSentenceCMSub.unsubscribe();
      }
    );

  }

  compareDate(date: Date) {
    return date.setHours(0, 0, 0, 0) != this.firstDate.setHours(0, 0, 0, 0);
  }

  recupLstColorMatching() {
    this.lstFilteredColorMatching = [];
    this.filterCM.filterStatus = this.filterForm.value['filterStatus'].map((x:any) => +x);
    this.filterCM.filterColorMatchingID = this.filterForm.value['filterColorMatchingID'] == "" || this.filterForm.value['filterColorMatchingID'] == null ? "" : this.filterForm.value['filterColorMatchingID'];
    this.colorMatchingSub = this.api.getLstColorMatching(this.filterCM).subscribe(
      data => {
        //console.log("recup");
        if (data != null) {
          this.lstColorMatching = [];
          data.forEach(element => {
            this.lstColorMatching.push(element);
            this.lstFilteredColorMatching.push(element);
          });
          //this.sortFile(this.sortDefault, "1");
          this.colorMatchingSource.data = this.lstFilteredColorMatching;
          if (Utils.isUserIxell(this.role))
            this.displayedColumns = this.displayedUser;
          else if (Utils.isCTC(this.role))
            this.displayedColumns = this.displayedCTC;
          else if (Utils.isAxalta(this.role))
            this.displayedColumns = this.displayedAXALTA;
        }
      },
      error => {
        console.log(error);
        if (this.colorMatchingSub != null) this.colorMatchingSub.unsubscribe();
      }
    );
  }

  changeFilter() {
    var listStatusContretypage = this.filterForm.controls["filterStatus"].value;

    if (listStatusContretypage == null || listStatusContretypage == "") {
      var statusList: any[] = [
        this.keys[0],
        this.keys[1],
        this.keys[2]
      ];
      this.filterForm.controls["filterStatus"].setValue(statusList);
      this.storageService.set("listStatusContretypage", statusList.join(","));
    } else {
      this.storageService.set("listStatusContretypage", listStatusContretypage.join(","));
    }
    this.recupLstColorMatching();
  }

  openModalReceive(colorMatching: IColorMatchingV1) {
    this.colMatching = colorMatching;
    let modal = document.getElementById("ModalReceive");
    modal.style.display = "block";
  }

  addDateReceive(id: number) {
    this.api.addDateReceive(id).subscribe(data => {
      if (data) {
        this.recupLstColorMatching();
        this.closeModalReceive();
      }
    });
  }

  closeModalReceive() {
    let modal = document.getElementById("ModalReceive");
    modal.style.display = "none";
  }

  /**
   * ouvre une modal d'après l'id passé en paramètre
   * @param idModal
   */
  openModal(idModal: string) {
    let modal = document.getElementById(idModal);
    modal.style.display = "block";
  }

  /**
   * ferme une modal d'après l'id passé en paramètre
   * @param idModal
   */
  closeModal(idModal: string) {
    let modal = document.getElementById(idModal);
    modal.style.display = "none";
  }

  visualColorMatching(res: IColorMatchingV1) {
    this.router.navigate(['/contretypage/response'], { state: { colormatchingID: res.colorMatchingID } });
  }

  print(res: IColorMatchingV1) {
    this.colMatching = res;
    this.colorMatchingSub = this.api.getColorMatching(res.colorMatchingID).subscribe(data => {

      console.log(data);

      this.colMatching = data;

      let listPaintQuality = this.colMatching.paintQuality.split(",");
      this.techDemande = "";
      for (let q in listPaintQuality) {
        this.techDemande += Technologie[+listPaintQuality[q]] + ", "
      }
      if (this.techDemande.length > 1)
        this.techDemande = this.techDemande.substring(0, this.techDemande.length - 2);

      if (data.response != null && this.compareDate(data.dateFinish)) {
        this.ingr = [];
        let array = data.response.sentences.split(",").map(Number);
        this.textSentencesCM = this.lstTextSentencesCM.filter(element => array.indexOf(element.id) > -1);
        this.techDemande = Technologie[this.colMatching.response.paintQuality];
        this.cumul = 0;
        data.response.ingredients.forEach(ingredient => {
          this.cumul += ingredient.quantity;
          ingredient.qtyCumule = Utils.roundDecimal(this.cumul, 3);
          this.ingr.push(ingredient);
          this.ingredientArray.data = this.ingr;
        });
        this.generateQRCode();

        if (data.response.responseMulti) {
          this.generateQRCodeFormuleMulti(data);
        }
      }

      setTimeout(function () {

        this.win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width / 2) + ",height=" + (screen.height / 2) + ",top=" + (100) + ",left=" + (100));

        let printHtml = '<html><head><link rel="stylesheet" href="assets/Impression/ImpressionContretypage.css"></head><body>';
        let headerPrint = '<div class="headerPrint">' + document.getElementsByClassName("headerPrint")[0].innerHTML + '</div>';
        let reportHtml = '<div class="contentPrint">' + document.getElementsByClassName("contentPrint")[0].innerHTML + '</div>';

        printHtml += headerPrint + '<table><caption></caption><thead><tr><td> ' + "" + ' </td></tr></thead><tbody><tr><td>' + reportHtml + ' </td></tr></tbody><tfoot><tr><td><div class="headerPrint"> <img class="footerImp" src="assets/bandeau.png" alt=""/></div></td></tr></tfoot></table></body><footer></footer></html>';
        this.win.document.write(printHtml);
        this.win.document.close();

        setTimeout(function () {
          this.win.print();
          this.win.close();
        }, 900);

      }, 900);

      //setTimeout(function () {
      //  window.print();
      //}, 1000);
    },
      error => {
        console.log(error);
        if (this.colorMatchingSub != null) this.colorMatchingSub.unsubscribe();
      });
  }

  //validerContretypage() {
  //  this.openModal('ModalEnCoursContretypage');

  //  //this.openModal('ModalInfirmationContretypage');

  //  //this.openModal('ModalConfirmContretypage');
  //}

  validerContretypage(res: IColorMatchingV1) {
    this.colMatching = res;
    this.colorMatchingSub = this.api.getColorMatching(res.colorMatchingID).subscribe(data => {
      this.colMatching = data;
      this.openModal('ModalEnCoursContretypage');
      this.colorMatchingValidationSub = this.api.validationContretypage( this.colMatching,this.storageService.get("CU")).subscribe(data => {
        this.closeModal('ModalEnCoursContretypage');
        if (data) {
          res.published = 2;
          this.openModal('ModalConfirmContretypage');
        } else {
          this.openModal('ModalInfirmationContretypage');
        }
      },
      error => {
        this.closeModal('ModalEnCoursContretypage');
        console.log(error);
        if (this.colorMatchingValidationSub != null) this.colorMatchingValidationSub.unsubscribe();
        this.openModal('ModalInfirmationContretypage');
      })
    },
    error => {
      this.closeModal('ModalEnCoursContretypage');
      console.log(error);
      if (this.colorMatchingSub != null) this.colorMatchingSub.unsubscribe();
      this.openModal('ModalInfirmationContretypage');
    });
  }

  exportContretypage(res: IColorMatchingV1) {
    this.ContretypageService.exportContretypage(res);
  }

  copieContretypage(res: IColorMatchingV1) {
    this.colMatching = res;
    res.duplicated = 1;

    this.colorMatchingSub = this.api.copieContretypage(res.colorMatchingID, this.storageService.get("CU")).subscribe(data => {

      this.lstColorMatching.push(data);
      this.lstFilteredColorMatching.push(data);

      this.colorMatchingSource = new MatTableDataSource<IColorMatchingV1>();
      this.colorMatchingSource.data = this.lstFilteredColorMatching;
      this.colorMatchingSource.paginator = this.paginator;
      this.colorMatchingSource.sort = this.sort;
      this.colorMatchingSource.sortingDataAccessor = (data, header) => data[header];

      //this.validerContretypage(res);

    },
      error => {
        if (this.colorMatchingSub != null) this.colorMatchingSub.unsubscribe();
        console.log(error);
      });
  }

  generateQRCode() {
    this.infoQRCode = "@LACA@0#";
    this.infoQRCode += this.colMatching.response.brandVehicle + "#";
    this.infoQRCode += this.colMatching.response.codeFormule + "#";
    this.infoQRCode += this.colMatching.response.designationPainting + "#";
    this.infoQRCode += "CONT" + "#";
    this.infoQRCode += this.colMatching.dateFinish.toLocaleDateString().replace(/\//gi, "") + "#";
    this.infoQRCode += this.techDemande; //Technologie[this.colMatching.response.paintQuality];
    for (let i = 0; i < this.colMatching.response.ingredients.length; i++) {
      let w: string = this.colMatching.response.ingredients[i].quantity.toString();
      this.infoQRCode += "#" + this.colMatching.response.ingredients[i].code + "|" + this.colMatching.response.ingredients[i].quantity.toFixed(3); //Number.parseFloat(this.colMatching.response.ingredients[i].quantity.toString().substr(0, w.indexOf(".") + 3)).toFixed(2);
    }
    this.api.generateQRCode(this.infoQRCode).subscribe(data => {
      this.qrcode = data;
    });
  }

  /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
  /**
   * Génération du QRCode pour l'impression
   */
  generateQRCodeFormuleMulti(data: IColorMatchingV1) {

    for (var i = 0; i < data.response.responseMulti.length; i++) {
      var infoQRCodeMutli = "@LACA@0#";
      infoQRCodeMutli += data.response.brandVehicle + "#";
      infoQRCodeMutli += data.response.codeFormule + "#";
      infoQRCodeMutli += data.response.designationPainting + "#";
      infoQRCodeMutli += "CONT" + "#";
      infoQRCodeMutli += data.dateFinish.toLocaleDateString().replace(/\//gi, "") + "#";
      infoQRCodeMutli += this.techDemande;  //Technologie[this.colMatching.response.paintQuality]; //this.techDemande;
      var cumul = 0;
      for (var j = 0; j < data.response.responseMulti[i].ingredients.length; j++) {


        var code = data.response.responseMulti[i].ingredients[j].code;
        var tmpName = this.AllIngredientArray.find(function (e) { return e.code == code });

        if (tmpName) {
          data.response.responseMulti[i].ingredients[j].name = tmpName.name;
        } else {
          data.response.responseMulti[i].ingredients[j].name = "unknow";
        }

        //data.response.responseMulti[i].ingredients[j].name = ;
        data.response.responseMulti[i].ingredients[j].qtyCumule = Utils.roundDecimal(cumul + data.response.responseMulti[i].ingredients[j].quantity, 3);
        cumul += data.response.responseMulti[i].ingredients[j].quantity;

        infoQRCodeMutli += "#" + data.response.responseMulti[i].ingredients[j].code;
        let w: string = data.response.ingredients[i].quantity.toString();
        infoQRCodeMutli += "|" + data.response.responseMulti[i].ingredients[j].quantity.toFixed(3); //Number.parseFloat(data.response.responseMulti[i].ingredients[j].quantity.toString().substr(0, w.indexOf(".") + 3)).toFixed(2);

      }
      this.api.generateQRCodeMulti(infoQRCodeMutli, i).subscribe(data => {
        document.getElementById("qrCodeContretypage-" + data.idFormule).innerHTML = '<div> <img class="thumbnail" src="data:image/png;base64,' + data.qrCode + '" alt=""/> </div>';
      });
    }

  }

  sortFile(sort: Sort, status: string) {
    var data = this.lstFilteredColorMatching;
    Constants.sortScale(sort, status, data)

    this.lstFilteredColorMatching = data.slice();
    this.colorMatchingSource = new MatTableDataSource(this.lstFilteredColorMatching);
  }

  
}
